import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  provider: 'okta',
  state: 'enabled',
  accessToken: () => faker.string.uuid(),
  createdAt: () => faker.date.recent(),
  updatedAt: () => faker.date.recent(),
  locationMapping: null,
});
